export default "__VITE_ASSET__45b4ef22__"